import { expertise } from '../data/portfolio';
import { SectionLabel } from './ui';

export function Expertise() {
  return (
    <section className="expertise-section section-space container" id="expertise" aria-labelledby="expertise-heading">
      <SectionLabel number="03">Skills & tools</SectionLabel>
      <div className="section-heading-row"><h2 id="expertise-heading">Expertise</h2><p>Front-end development is the foundation of my work, with a specialization in e-commerce and Shopify.</p></div>
      <div className="expertise-grid">{expertise.map(group => (
        <article className="expertise-card" key={group.number}><span className="expertise-number">{group.number}</span><div><h3>{group.title}</h3><ul>{group.skills.map(skill => <li key={skill}>{skill}</li>)}</ul></div></article>
      ))}</div>
    </section>
  );
}
